import axios from 'axios'
import store from '~/store'
import router from '~/router'
import swal from 'sweetalert2'

import { regExpTest, getBoolValue } from './helper'
import is from '../web/plugins/helper/is'

const setupSwal = () => {
  return swal.mixin({
    position: 'center',
    cancelButtonColor: '#d33',
    confirmButtonColor: '#3085d6',
    confirmButtonText: swal.i18n.t('ok'),
    cancelButtonText: swal.i18n.t('cancel'),
    showCancelButton: true,
    allowOutsideClick: () => false,
  })
}

axios.interceptors.request.use(request => {
  const verified = regExpTest(/api/, request.url || '')
  if (verified === true && ['get', 'GET'].indexOf(request.method) !== -1) {
    request.headers.get['Accept'] = 'application/json'
    request.headers.get['Content-Type'] = 'application/json'
  }

  store.commit('GLOBAL_CHARGE_START')
  if (store.getters.authToken) {
    request.headers.common['Authorization'] = `Bearer ${store.getters.authToken}`
  }

  const metaToken = is.getNode('meta[name="csrf-token"]')
  if (is.node(metaToken)) {
    const token = is.getUniqueAttribute(metaToken, 'content')
    if (is.checkVariable(token)) {
      request.headers.common['X-CSRF-TOKEN'] = token
    }
  }

  return request
}, error => {
  store.commit('GLOBAL_CHARGE_SUCCESS')

  return Promise.reject(error)
})

axios.interceptors.response.use(response => {
  store.commit('GLOBAL_CHARGE_SUCCESS')

  return response
}, error => {
  store.commit('GLOBAL_CHARGE_SUCCESS')

  if (error && error.response) {
    const { status, data } = error.response
    if (status) {
      let message = ''
      if (data && data.message) {
        message = data.message
      }
      switch (status) {
        case 401:
          if (store.getters.authCheck) {
            const newSwal = setupSwal()
            newSwal.fire({
              icon: 'warning',
              title: swal.i18n.t('error_alert_title'),
              text: `${swal.i18n.t('token_expired_alert_text')}${message ? `: ${message}` : ''}`,
            }).then(async () => {
              await store.dispatch('setLastRouteExpired', store.getters.state_route)
              await store.commit('LOGOUT')
              router.push({ name: 'login' })
            })
          }
          break
        case 403:
          if (store.getters.authCheck && data.factor2 !== undefined && getBoolValue(data.factor2) === true) {
            const newSwal = setupSwal()
            newSwal.fire({
              icon: 'warning',
              title: swal.i18n.t('error_alert_title'),
              text: `${swal.i18n.t('not_permission_alert_text')}${message ? `: ${message}` : ''}`,
            }).then(async () => {
              // Save 2-step
              store.dispatch('save2StepAuth', { ...data })
              router.push({ name: 'two_step' })
            })
          } else if (store.getters.authCheck) {
            const newSwal = setupSwal()
            newSwal.fire({
              icon: 'warning',
              title: swal.i18n.t('error_alert_title'),
              text: swal.i18n.t('not_permission_alert_text'),
            }).then(async () => {
              router.push({ name: 'login' })
            })
          }
          break
        case 422:
          if (store.getters.authCheck && data) {
            const { errors } = data
            let html = ''
            if (errors) {
              html = '<table>'
              Object.keys(errors).forEach(error => {
                html = html + '<tr>'
                html = html + `<th>${error}</th>`
                html = html + `<td>${errors[error]}</td>`
                html = html + '</tr>'
              })
              html = html + '</table>'
            }
            const newSwal = setupSwal()
            newSwal.fire({
              title: 'Error: <u>Por favor verifica los siguientes campos en el formulario.</u>',
              icon: 'error',
              html,
              showCloseButton: true,
              showCancelButton: false,
            })
          }
          break
        default:
          if (status >= 500) {
            const newSwal = setupSwal()
            newSwal.fire({
              icon: 'error',
              title: swal.i18n.t('error_alert_title'),
              text: `${swal.i18n.t('error_alert_text')}${message ? `: ${message}` : ''}`,
            })
          }
          break
      }
    }

    return Promise.reject({
      status,
      ...error,
    })
  }

  return Promise.reject(error)
})
